var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.collapsible
        ? _c(
            "button",
            {
              staticClass: "entity__collapsible",
              attrs: { type: "button", "aria-label": _vm.trans("SHOW_MORE") },
              on: { click: _vm.toggleCollapse },
            },
            [
              _vm.collapsed
                ? _c("i", {
                    staticClass: "fa fa-plus",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c("i", {
                    staticClass: "fa fa-minus",
                    attrs: { "aria-hidden": "true" },
                  }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("trigger"),
      _vm._v(" "),
      _c("div", { class: _vm.collapsedClass }, [_vm._t("target")], 2),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }